import Photo from './Photo';
import SmartLink from './SmartLink';
import { Horizon, Peeks, splitArt } from './Art';

function Release({ release }) {
  const firstLink = release.links[0];
  const coverHref = release.coverLink || (firstLink && firstLink.url);
  return (
    <article className="release">
      <div className="release-cover">
        {release.badge && <span className="sticker">{release.badge}</span>}
        <SmartLink url={coverHref} className="tile-frame release-frame" aria-label={`Listen to ${release.title}`}>
          <Photo src={release.cover} alt={`${release.title} album cover`} fallback />
        </SmartLink>
      </div>
      <div className="release-body">
        <h3 className="display display--m">{release.title}</h3>
        {release.quote && (
          <blockquote className="pull">
            <p>{release.quote}</p>
            {release.quoteSource && <footer>{release.quoteSource}</footer>}
          </blockquote>
        )}
        {release.links.length > 0 && (
          <div className="btn-row">
            {release.links.map((l, i) => (
              <SmartLink key={l.key} url={l.url} className={`btn ${i === 0 ? 'btn--solid' : 'btn--line'}`}>{l.label}</SmartLink>
            ))}
          </div>
        )}
      </div>
    </article>
  );
}

function Record({ item }) {
  return (
    <SmartLink url={item.href} className="record">
      <span className="record-art tile-frame"><Photo src={item.image} alt={`${item.title} cover`} fallback /></span>
      <span className="record-meta">
        <strong>{item.title}</strong>
        <span className="record-kind">{item.kind}</span>
      </span>
      {item.desc && <span className="record-desc">{item.desc}</span>}
    </SmartLink>
  );
}

export default function Music({ heading, release, recordings, labels, art }) {
  const { peeks, horizon } = splitArt(art);
  return (
    <section id="music" className={`sec sec--sky music ${horizon ? 'sec--horizon' : ''}`} aria-labelledby="music-title">
      <Peeks items={peeks} />
      <div className="wrap">
        <h2 id="music-title" className="display">{heading}</h2>
        {release.show && <Release release={release} />}
        {recordings.length > 0 && (
          <div className="shelf">
            <h3 className="display display--s">{labels.recordings}</h3>
            <div className="shelf-grid">
              {recordings.map((item) => <Record key={item.key} item={item} />)}
            </div>
          </div>
        )}
      </div>
      {horizon && <Horizon name={horizon.name} />}
    </section>
  );
}
